import { useMemo } from 'react'

export const useQueryFlags = () => {
  const queryFlags = useMemo(() => {
    if (typeof window === 'undefined') {
      return []
    }
    const flags = new URLSearchParams(window.location.search).get('ff')
    return flags ? flags.split(',') : []
  }, [])

  return { queryFlags }
}
